module.exports = __webpack_public_path__ + "static/media/web-color-startups-leftaligned.8dfb1a7f.svg";